import React from 'react'
import qaCallout from './qa-callout'

const doc = {
  title: 'Q&A: How to create that pattern in Revit?',
  slug: 'qa-how-to-create-that-pattern-in-revit',
  tags: ['forum', 'q&a', 'question', 'answer'],
  category: 'q-and-a',
  content: (props) => {
    return <div>
      {qaCallout}
      <p>
        <a href="https://forums.autodesk.com/t5/revit-architecture-forum/how-to-create-that-pattern-in-revit/m-p/9643109/highlight/false#M290335" target="_blank" rel="noreferrer">Read more of this thread on forums.autodesk.com</a>
      </p>
      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title">Asked by <a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5935396" target="_blank" rel="noreferrer">@alex.motion</a> on 7/19/2020 on the Revit Architecture Forum:</strong><br/>
        Hi !<br/>
        How to create that pattern in revit ?<br/>
        I tried from materials but has nothing like that in templates , tried with linestyles but how do I create 1 dashed and one whole line pattern ?
        <br/>
        <img src="/img/forum_content/concrete.png"/>
      </blockquote>
      
      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 7/19/2020:</strong><br/>
        Pattycake has a bunch of free pre-built PAT files in our library that would work for you... Or you could just customize and make your own.<br/>
        Our draw in web is free for up to 3 lines, which you can make this one with just 2. Nothing to download or install 😎<br/>
        <a href="https://pattycake.io/official/pat/Yl3lJmwOwb4" target="_blank">https://pattycake.io/official/pat/Yl3lJmwOwb4</a>
        <br/>
        <img src="/img/forum_content/Concrete2Lines.gif" width="98%"/>
      </blockquote> 

    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/qa-how-to-create-that-pattern-in-revit.js